import { ShareVideoToLinkedinMeta, ShareVideoToLinkedinPayload } from 'types/store/ShareVideoToLinkedin';
import { createAsyncReducer } from 'utils/Redux';

import { shareVideoToLinkedinActions } from '../actions';

export default createAsyncReducer<ShareVideoToLinkedinMeta, ShareVideoToLinkedinPayload>(shareVideoToLinkedinActions);
